import { render, staticRenderFns } from "./TreesStatusAndNumber.vue?vue&type=template&id=c2c0f84c&scoped=true&"
import script from "./TreesStatusAndNumber.vue?vue&type=script&lang=js&"
export * from "./TreesStatusAndNumber.vue?vue&type=script&lang=js&"
import style0 from "./TreesStatusAndNumber.vue?vue&type=style&index=0&id=c2c0f84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c0f84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VRow})
